import React, { Fragment, MutableRefObject, useContext, useEffect, useRef, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";

import { useContextMenu } from "app/hooks";

import { CreatomateContext } from "../../contexts/VideoStudioContext";
import ElementContextOptions from "./context-menu/ElementContextOptions";
import DraggableImageElement from "./draggable-element/DraggableImageElement";

interface ImageElementProps {
  currentElement: ElementState;
  preview: Preview;
}

const ImageElement: React.FC<ImageElementProps> = ({
  currentElement,
  preview
}) => {
  const { data: { activeElementsId } } = useContext(CreatomateContext);

  const barRef = useRef() as MutableRefObject<HTMLDivElement>;

  const onContextMenu = () => {
    if (!activeElementsId.includes(currentElement.source.id)) {
      preview.setActiveElements([currentElement.source.id]);
    }
  };

  const {
    contextMenuVisible,
    contextMenuPosition,
    contextMenuRef,
    handleContextMenu,
    handleSetContextMenuVisible
  } = useContextMenu(onContextMenu);

  return (
    <Fragment>
      <ElementContextOptions
        contextMenuPosition={contextMenuPosition}
        contextMenuVisible={contextMenuVisible}
        contextMenuRef={contextMenuRef}
        currentElement={currentElement}
        onSetContextMenuVisible={handleSetContextMenuVisible}
        preview={preview}
      />
      <DraggableImageElement
        barRef={barRef}
        currentElement={currentElement}
        onContextMenu={handleContextMenu}
        preview={preview}
      />
    </Fragment>
  );
};

export default ImageElement;
